<script lang="ts">
	import Layout from "@components/layout/Layout.svelte";
	import checkmark from "@core/assets/icons/checkmark.svg";
</script>

<Layout>
	<section class="pt-20 pb-16 [&_h3]:mb-3 [&_h3]:mt-5 [&_p]:mb-3">
		<h2 class="mb-12">Etický kodex</h2>
		<h3 class="mb-6">Zásady chování</h3>
		<p>
			Ve společnosti Novakon dbáme na vystupování a mezilidské vztahy, a to nejen na pracovišti, ale i směrem ven z
			firmy. Považujeme to za základní povinnost každého z nás. Všichni zaměstnanci firmy se těmito zásadami řídí a
			vytvářejí tak obrázek o společnosti.
		</p>

		<p>
			Společnost se proto rozhodla vydat tyto obecně platné zásady písemně, aby tak usnadnila jejich šíření a umožnila
			zavádění těchto pravidel ve všech částech společnosti a ve všech jejích pobočkách.
		</p>

		<p>
			Dodržování těchto principů je základním požadavkem firmy Novakon a zároveň známkou příslušnosti k této
			společnosti.
		</p>

		<ul
			style:list-style-image="url({JSON.stringify(checkmark)})"
			class="*:marker:text-6 list-inside *:marker:leading-0 *:mb-4 ml-4"
		>
			<li>
				Společnost&nbsp;Novakon&nbsp;považuje za základní principy, které vedou k lidskosti a dobrému jménu, tyto
				hodnoty:
			</li>

			<li>
				Společnost Novakon je zakázková společnost a tak je její zákazník a uspokojení jeho potřeb vždy na prvním místě.
				K našim zákazníkům, a to jak vnitřním, tak vnějším, vždy přistupujeme s úctou a snažíme se vyjít vstříc v
				maximální možné míře.
			</li>

			<li>
				Profesionalita pro nás také znamená důraz na osobní rozvoj každého jednotlivce, který tak roste se společností a
				neustále ji udržuje na vysoké úrovni. To vyžaduje osobní zaujetí, ochotu přijmout přidělené úkoly a vůli
				dosáhnout potřebných znalostí.
			</li>

			<li>
				Práce v týmu je základní princip práce ve společnosti Novakon. Proto klademe důraz na týmové chování a jednání,
				které zahrnuje nejen spolupráci s kolegy, ale také respektování práce ostatních. Jen silný tým lidí je schopen
				vytvářet hodnoty a posunovat společnost dál.
			</li>

			<li>
				Za všech okolností je povinností každého zaměstnance hájit dobré jméno firmy a vystupovat v souladu s dobrou
				pověstí této společnosti. Současně to znamená neslučitelnost jakéhokoli prosazování vlastních zájmů, které by
				bylo v rozporu se zájmy společnosti. Předpokládá se dodržování vnitřních směrnic a interních pravidel.
			</li>

			<li>
				Ve firmě Novakon je věnován velký prostor pro výchovu nových talentů. Dáváme šanci všem kolegům, kteří mají
				potenciál a chuť něco dokázat. Plánujeme jejich kariérní růst a provázíme je osobním růstem. Zároveň
				zapracováváme nové kolegy na bázi plánů zaučení a jejich pravidelné revize v rámci zpětné vazby.
			</li>

			<li>
				Každý zaměstnanec společnosti Novakon je povinen respektovat druhého kolegu, bez ohledu na jeho věk, vyznání
				nebo národnostní příslušnost. Současně vyžadujeme respektování názorů ostatních, i když se nemusejí shodovat s
				názorem daného jedince. Je důležité, aby všichni respektovali osobní a pracovní prostor každého a plánovali
				osobní schůzky a pracovní záležitosti s ohledem na časový plán jednotlivce. To zahrnuje i včasné plnění závazků
				jednoho vůči druhému a v případě neschopnosti dodržet daný termín včasné omluvení se a navržení nového termínu.
			</li>

			<li>
				Uvědomujeme si, že ne každý má dostatečný přístup ke zdrojům a jsou naplňovány jeho základní potřeby. Společnost
				Novakon vnímá jako svou povinnost pomáhat svou prací těm, kteří nemají ve společnosti takové štěstí. Ročně proto
				uvolňuje rozpočet na charitativní účely, který je v průběhu roku rozdělen jak v rámci České republiky, tak do
				zemí třetího světa.
			</li>

			<li>
				Společnost Novakon je zakázková společnost a tak je její zákazník a uspokojení jeho potřeb vždy na prvním místě.
				K našim zákazníkům, a to jak vnitřním, tak vnějším, vždy přistupujeme s úctou a snažíme se vyjít vstříc v
				maximální možné míře.
			</li>

			<li>
				Záměrem společnosti Novakon je stanovit zásady jednání, které by upravovaly činnost všech pracovníků při výkonu
				práce. Tyto zásady jednání přispívají k zajištění odpovědného a trvale udržitelného rozvoje zodpovědnými cestami
				růstu v souladu s dlouhodobou strategií firmy.
			</li>

			<li>
				Společnost Novakon se striktně drží platných zákonů v zemi, ve které podniká. Zvláštní pozornost je věnována
				zásadě, kdy se společnost zdržuje financování jakékoli politické strany nebo politické činnosti a odmítá
				jakoukoli formu aktivní nebo pasivní korupce.
			</li>

			<li>
				Dbáme na udržování pořádku a čistoty na všech pracovištích firmy, stejně jako na vybavenost areálu. Jsme si
				vědomi, že v dobrých podmínkách a s dobrým vybavením můžeme tvořit kvalitní stroje, které uspokojí potřeby
				zákazníků. Zároveň je odpovědností každého jednotlivce udržovat své pracoviště v čistotě nejen po skončení
				pracovní směny, ale i v jejím průběhu.
			</li>

			<li>
				Dbáme na dodržování zásad ochrany životního prostředí a to nejen tříděním odpadu, ale i dodržováním správného
				nakládání s nebezpečnými odpady jako jsou oleje, emulze aj. Společnost má trvalý zájem na zlepšování kvality
				životního prostředí a respektuje při podnikatelské činnosti normy stanovené pro oblast odpadů, emisí apod.
			</li>

			<li>
				Naše vztahy s dodavateli jsou založeny na vzájemném respektu a korektnosti. Pečlivě naše externí dodavatele
				vybíráme. Jakékoli propagační a dárkové předměty, které dostáváme, nepřijímáme za žádných okolností a v případě,
				že se nám nějaké objeví, věnujeme tyto do charitativních organizací. Vnímáme to jako důležitý signál proti
				případné korupci.
			</li>

			<li>
				Společnost Novakon si počíná v konkurenčním boji rázně, ale čestně. Zakládáme si na korektních vztazích a nikdy
				nepoškozujeme reputaci našich konkurentů. Dbáme, aby zaměstnanci ve styku s konkurencí respektovali důvěrnost
				obchodních či jinak důvěrných informací. Společnost se nepokouší nečestnými způsoby získat informace o podnikání
				konkurentů a stejně tak nepoužívá restriktivní obchodní praktiky ani nezneužívá v žádné formě své postavení na
				trhu.
			</li>
		</ul>
	</section>
</Layout>
